import React from 'react';
import {useSelector} from 'react-redux';
import {get, noop} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS} from '/enum/reportCard.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import withRecordPopover from '../withRecordPopover';

import {EligibleClientSupportBonusPlusContent} from './EligibleClientSupportBonusPlusContent';
import reportPayload from './reportPayload';
interface EligibleClientSupportBonusPlusReportProps {
  loadingData: {
    total?: number;
  };
  showRecordPopover: () => void;
}

export const EligibleClientSupportBonusPlusReport: React.FC<
  EligibleClientSupportBonusPlusReportProps
> = ({loadingData = {}, showRecordPopover = noop}) => {
  const featureFlag = useSelector(variablesFeatureFlag);
  const showEnhancedCSBPlus = get(featureFlag, 'showEnhancedCSBPlus', false);
  const {tt} = useTranslation('report.eligibleClientSupportBonusPlusReport');
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt(
        'title',
        showEnhancedCSBPlus
          ? 'Client Support Bonus+'
          : 'Eligible for Client Support Bonus+',
      )}
      description={tt(
        'description',
        showEnhancedCSBPlus
          ? 'These are your coaches currently eligible for the Client Support Bonus+ Encourage them to sign up 2 new clients to earn a 3% bonus! After welcoming 2 new clients, both new and reactivated clients will help them increase their bonus to 5% or 7%!'
          : 'These Coaches are currently eligible for a Client Support Bonus+. Help encourage them to sign up new Clients this month to get it!',
      )}
      isCSBReport={true}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EligibleClientSupportBonusPlusContent}
    />
  );
};

export const EligibleClientSupportBonusPlusReportWithRecordPopover =
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
    popoverContentProps: {},
  })(EligibleClientSupportBonusPlusReport);
